import CategoryNavMobileComponent from '../components/CategoryNavMobile';
import { connect } from 'react-redux';

const CategoryNavMobile = connect((state) => state)(CategoryNavMobileComponent);

export default CategoryNavMobile;
